import React, { useEffect } from "react";
import {
  Modal,
  Image,
} from "antd";
import "./Delivery.scss";


export default function ViewDeliveryProof(props) {
  useEffect(() => {
    console.log(props.proofs);
  }, [props.proofs]);

  return (
    <Modal
      title={"Delivery Proof"}
      open={props.modalOpen}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <div className="photo-grid">
          {props.proofs.map((item) => (
              <Image width={150} src={item} />
          ))}
      </div>
    </Modal>
  );
}
